import { render, staticRenderFns } from "./Ramplas.vue?vue&type=template&id=705463a6&scoped=true&"
import script from "./Ramplas.vue?vue&type=script&lang=ts&"
export * from "./Ramplas.vue?vue&type=script&lang=ts&"
import style0 from "./Ramplas.vue?vue&type=style&index=0&id=705463a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705463a6",
  null
  
)

export default component.exports